import React from 'react'
import { Autocomplete, TextField } from '@mui/material'

const AuthorSelector = ({ name, label, authors, value, disabled = false, loading = false, handleChange }) => {
  const isDisabled = disabled || loading
  const handleOnChange = React.useCallback((inputValue) => {
    if (inputValue && inputValue.name) {
      return handleChange(inputValue.name)
    } else {
      return handleChange(inputValue ?? '')
    }
  }, [handleChange])

  return (
    <Autocomplete
      id={`${name}-selector`}
      data-test={`${name}-selector`}
      freeSolo
      disabled={isDisabled}
      value={value}
      options={authors}
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          return option
        }

        return option?.name
      }}
      isOptionEqualToValue={(option) => {
        return option.name === value
      }}
      onInputChange={(_, newInputValue) => {
        handleOnChange(newInputValue)
      }}
      onChange={(_, newValue) => {
        handleOnChange(newValue)
      }}
      renderInput={params => (
        <TextField {...params} label={label} variant='outlined' value={value} />
      )}
    />
  )
}

export default AuthorSelector
